// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__zD5PH","detailsContainer":"Summary_detailsContainer__UCq0E","item":"Summary_item__Z9DhB","total":"Summary_total__xm+Pf"};